<template>
  <div c_name="IosDownMobile">
    <!--
    <div class="ios_bad" @click="onOpenBad" v-show="!showBad">
      没有掉签却无法安装的玩家<span style="color: #005cf5; padding: 0.6rem 0.4rem;">请点击此处</span>
    </div>
    <div class="ios_bad" v-show="showBad" @click="onCloseBad">
      <span style="color: #005cf5; padding: 0.6rem 0.4rem;">返 回</span>
    </div>
    -->
    <img class="ios_img" :src="showData.iosTips" alt="" v-show="!showBad">
    <img class="ios_img" src="@/assets/ios_bad_install.jpg" alt="" v-show="showBad">
    <div>
      <img class="ios_down" :src="showData.iosPic" alt="" @click="onDown">
    </div>
  </div>
</template>
<script>
// @ is an alias to /src

import tools from '@/tools/tools'

export default {
  name: 'IosPrivDownMobile',
  components: {
  },
  data: () => {
    return {
      showBad: false
    }
  },
  mounted () {
    this.onToTop()
  },
  created () {

  },
  methods: {
    onDown () {
      tools.iosDoLocation(this.$store.getters.getDownIos(this.downKey))
    },
    onToTop () {
      document.body.scrollTop = document.documentElement.scrollTop = 0
    },
    onOpenBad () {
      this.onToTop()
      this.showBad = true
    },
    onCloseBad () {
      this.onToTop()
      this.showBad = false
    }
  },
  computed: {
    downKey () {
      // 私发包，写死
      return 'ytmjPriv'
    },
    showData () {
      return this.$store.state.configs.download[this.downKey]
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ios_bad {
  position: fixed;
  background: #f8f8f8;
  top: 3rem;
  left: 0;
  right: 0;
  height: 3rem;
  line-height: 3rem;
  font-weight: bold;
}
.ios_img {
  margin-top: 4rem;
  width: 100%;
}
.ios_down {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
}
</style>
